import { axiosClient, getCSRFToken } from 'www/utils'

/**
 * @description Запрашивает связки врач-оборудование
 *
 * @param {object} requestData - данные запроса
 * @param { number } requestData.age - возраст пациента
 * @param { number } requestData.lpuId - id клиники
 * @param { number } requestData.synonymId - id синонима/услуги
 * @param { string } requestData.appointmentDate - выбранное время записи (слот)
 */
function getDoctorEquipmentRelations({
  age,
  lpuId,
  synonymId,
  appointmentDate,
}) {
  return axiosClient({
    url: '/ajax/diagnostika/services/relations/',
    method: 'POST',
    data: {
      age,
      lpu: lpuId,
      synonym: synonymId,
      slot: appointmentDate,
    },
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': getCSRFToken(),
    },
  })
    .then(({ data }) => data)
}

export default getDoctorEquipmentRelations
